<template>
  <div class="dialog-warp">
    <el-form ref="info" size="small" label-position="top">
      <!-- ------------------------------------------ 通行码 -------------------------------------- -->
      <el-row class="dialog-form" v-if="this.activeId==1">
        <el-col class="g-basic-info">
          <el-row>
            <el-col :span="12">
              <p>
                园区通行码：
              </p>
              <el-col>
                <el-row type="flex" align="bottom">
                  <div style="width:74px;height:74px;margin-right:10px;">
                    <img :src='imgUrl' alt="" style="width:100%;object-fit:contain;">
                  </div>
                <!-- <div style="width:98px;height:25px;border-radius:5px;background-color:#fff;border:1px solid #797979;text-align:center;">下载</div> -->
                  <el-button size="mini" @click.stop="dowloadImg">下 载</el-button>
                </el-row>
              </el-col>
            </el-col>
            <el-col :span="12">
              <p>
                通行码状态：
                <span class="green" v-if="healthCode.healthCodeType==1">自由通行</span>
                <span class="red" v-if="healthCode.healthCodeType==2">受限制</span>
              </p>
              <p style="margin-top:20px;">
                档案编码：
                <span>{{healthCode.healthCodeContent}}</span>
              </p>
            </el-col>
          </el-row>

        </el-col>
        
      </el-row>

      <!-- ---------------------------------------------------------基本信息--------------------------------------------- -->
      <h3 class="title">
        基本信息：
        <span class="title-label-right">{{vrInfo.erCreateTime}} 登记</span>
      </h3>
      <el-row class="dialog-form">
        <el-col class="g-basic-info">
          <el-row>
            <el-col :span="12">
              <p>
                姓名：
                <span>{{vrInfo.baseName}}</span>
              </p>
            </el-col>
            <!-- <el-col :span="16"><p>性别：<span v-if="vrInfo.vrSex==1">男</span><span v-if="vrInfo.vrSex==2">女</span><span v-if="vrInfo.vrSex==3">未知</span></p></el-col> -->
            <el-col :span="12">
              <p>
                户籍地址：
                <span>{{vrInfo.baseProvince}} - {{vrInfo.baseCity}} - {{vrInfo.baseDistrict}}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <p>
                所在企业：
                <span>{{vrInfo.baseCompanyName}}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <p>
                手机号码：
                <span>{{vrInfo.basePhone}}</span>
              </p>
            </el-col>
            <el-col :span="12">
              <p>
                身份证号码：
                <span>{{vrInfo.baseIdcrad}}</span>
              </p>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="12">
              <p>
                是否已返园复工：
                <span v-if="vrInfo.erIsRework==1" class="font-blod">已复工</span>
                <span v-if="vrInfo.erIsRework==2" class="font-blod">未复工</span>
              </p>
            </el-col>
            <el-col :span="12">
              <p>
               复工（包括预计复工）时间：
                <span>{{vrInfo.erHaveReworkTime==2?'需等待园区或企业通知':vrInfo.erReworkTime?new Date(vrInfo.erReworkTime).format('yyyy-MM-dd'):'-'}}</span>
              </p>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8"><p>当前位置：<span>{{vrInfo.erLocation}}</span></p></el-col>
          </el-row>-->
        </el-col>
        <el-col class="g-basic-info" style="border-top:1px solid #eee;">
          <el-row>
            <el-col :span="12">
              <p>
                是否返回工作所在地：
                <span v-if="vrInfo.erIsReturn==1" class="font-blod">已返回</span>
                <span v-if="vrInfo.erIsReturn==2" class="font-blod">未返回</span>
                <span v-if="vrInfo.erIsReturn==3" class="font-blod">未离开</span>
              </p>
            </el-col>
            <el-col :span="12" v-if="vrInfo.erIsReturn!=3">
              <p>
                返程时间：
                <span>{{vrInfo.erReturnTime?new Date(vrInfo.erReturnTime).format("yyyy-MM-dd"):''}}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <p>
                假期所在地区：
                <span>{{vrInfo.erHolidayProvince}} - {{vrInfo.erHolidayCity}} - {{vrInfo.erHolidayDistrict}}</span>
              </p>
            </el-col>
            <!-- <el-col :span="12" v-if="vrInfo.erIsReturn!=3">
              <p>
                离开工作地返乡时间：
                <span>{{vrInfo.erLeaveTime?new Date(vrInfo.erLeaveTime).format("yyyy-MM-dd"):'-'}}</span>
              </p>
            </el-col> -->
            <el-col :span="12">
              <p>
                假期所在地居住地址：
                <span>{{vrInfo.erHolidayAddress}}</span>
              </p>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <p>
                工作地居住地址：
                <span>{{vrInfo.erLocation}}</span>
              </p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <!-- ------------------------------------------- 防疫信息 ---------------------------------------------------- -->
      <h3 class="title">防疫信息：</h3>
      <el-row class="dialog-form">
        <el-col class="g-basic-info">
          <div class="info-item">
            <p class="item">
              假期使用通勤工具：
              <span>{{vrInfo.erIsAirplane==1?'飞机':''}} {{vrInfo.erIsBulletTrain==1?'动车':''}} {{vrInfo.erIsBus==1?'客车':''}} {{vrInfo.erIsPrivateCar==1?'私家车':''}}</span>
            </p>
            <p class="item" v-if="vrInfo.erIsAirplane==1">
              航班号:
              <span>{{vrInfo.erFlightNumber}}</span>
            </p>
            <p class="item" v-if="vrInfo.erIsBulletTrain==1">
              动车班次:
              <span>{{vrInfo.erTrainService}}</span>
            </p>
            <p class="item" v-if="vrInfo.erIsBus==1">
              客车班次:
              <span>{{vrInfo.erBusNumber}}</span>
            </p>
            <!-- <span class="item">行程详情描述：<span>{{vrInfo.vrTrainRemark}}</span></template> -->
          </div>
          <div class="info-item">
            <p class="item">
              本人是否有发热、乏力、干咳等症状：
              <span class="green" v-if="vrInfo.erHealth==1">无</span>
              <span class="red" v-if="vrInfo.erHealth==2">有</span>
            </p>
            <p class="item" v-if="vrInfo.erHealth==2">
              症状描述：
              <span>{{vrInfo.erHealthRemark}}</span>
            </p>
          </div>
          <div class="info-item">
            <p class="item">
              家人、同住、邻居是否有发热、乏力、干咳等症状：
              <span class="green" v-if="vrInfo.erFamilyHealth==1">无</span>
              <span class="red" v-if="vrInfo.erFamilyHealth==2">有</span>
            </p>
            <p class="item" v-if="vrInfo.erFamilyHealth==2">
              症状描述：
              <span>{{vrInfo.erFamilyHealthRemark}}</span>
            </p>
          </div>
          <div class="info-item">
            <p class="item">
              是否有新型冠状感染者（包括疑似病例）接触史：
              <span class="green" v-if="vrInfo.erContactHistory==1">无</span>
              <span class="red" v-if="vrInfo.erContactHistory==2">有</span>
            </p>
            <p class="item" v-if="vrInfo.erContactHistory==2">
              情况描述：
              <span>{{vrInfo.erContactHistoryRemark}}</span>
            </p>
          </div>
          <div class="info-item">
            <p class="item">
              是否有疫区（湖北、温州等地区）停留史：
              <span class="green" v-if="vrInfo.erContact==1">无</span>
              <span class="red" v-if="vrInfo.erContact==2">有</span>
            </p>
            <p class="item" v-if="vrInfo.erContact==2">
              情况描述：
              <span>{{vrInfo.erContactRemark}}</span>
            </p>
          </div>
           <div class="info-item">
            <p class="item">
              是否已按工作属地政策需求，完成居家隔离7/14天：
              <span class="red" v-if="vrInfo.erIsIsolation==2">无</span>
              <span class="green" v-if="vrInfo.erIsIsolation==1">有</span>
            </p>
            <!-- <p class="item" v-if="vrInfo.erIsIsolation==1">
              隔离时间：
              <span>{{new Date(vrInfo.erIsolationStartTime).format("yyyy-MM-dd")}} 至 {{new Date(vrInfo.erIsolationEndTime).format("yyyy-MM-dd")}}</span>
            </p> -->
          </div>
          <div class="info-item">
            <p class="item">
              其它备注信息：
              <span>{{vrInfo.erOtherRemark}}</span>
            </p>
          </div>
        </el-col>
      </el-row>
<!-- ------------------------------------------------------- 隔离登记信息 ------------------------------------------------- -->
      <h3 class="title" v-if="this.activeId==1">隔离登记信息：</h3>
      <el-row class="dialog-form" v-show="quarantine==null&&this.activeId==1">
        <el-col class="g-basic-info">
          <el-row>
            <el-col :span="20">
              <p class="quarantine-condition" style="color:#008000;">未进行隔离登记</p>
            </el-col>
            <el-col :span="2">
              <el-button size="mini" @click.stop="quarantineRegisterAddDialog=true">隔离登记</el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="dialog-form" v-show="quarantine!=null&&this.activeId==1">
        <el-col class="g-basic-info">
          <el-row style="margin-bottom:10px;">
            <el-col :span="13">
              <p class="quarantine-condition" style="color:#FF0000;">隔离中</p>
            </el-col>
            <el-col :span="6">
              <el-button size="mini" @click.stop="relieveTheIsolation">解除隔离登记</el-button>
            </el-col>
            <el-col :span="2">
              <el-button size="mini" @click.stop="editTheIsolation">编辑隔离登记</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <p>
                隔离方式：
                <span v-show="quarantineInfo.quarantineWay==1">自我隔离</span><span v-show="quarantineInfo.quarantineWay==2">强制隔离</span>
              </p>
            </el-col>
            <el-col :span="12">
              <p>
                隔离登记时间：
                <span>{{quarantineInfo.quarantineStartTime}}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <p>
                隔离开始时间：
                <span>{{new Date(quarantineInfo.quarantineStartTime).format("yyyy-MM-dd")}}</span>
              </p>
            </el-col>
            <el-col :span="12">
              <p>
                隔离结束时间：
                <span>{{new Date(quarantineInfo.quarantineEndTime).format("yyyy-MM-dd")}}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <p>
                隔离时间：
                <span>{{quarantineInfo.quarantineDays}}</span>天
              </p>
            </el-col>
            <el-col :span="12">
              <p>
                登记人：
                <span v-if="quarantineInfo.companyName">{{quarantineInfo.companyName}} - {{quarantineInfo.quarantineAdminName}}</span>
                <span v-else>{{quarantineInfo.quarantineAdminName}}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <p>
                监管负责人：
                <span>{{quarantineInfo.quarantinePerson}}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <p>
                情况描述：
                <span>{{quarantineInfo.quarantineDescription}}</span>
              </p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>

    <!--     <div class="text-right" style="margin-top: 20px;">
      <el-button type="success" @click="close" size="small">确认</el-button>
    </div>-->

    <el-dialog title="隔离登记" :visible.sync="isolationDialog" width="400px" center append-to-body mini>
      <el-row class="dialog-form" v-show="isEdit">
        <el-col class="g-basic-info">
          <div class="info-item">
            <p style="padding:15px;">该员工已进行隔离登记，是否更新隔离登记记录？</p>
          </div>
        </el-col>
      </el-row>

      <el-row class="dialog-form" v-show="isRelieve">
        <el-col class="g-basic-info">
          <div class="info-item">
            <p style="padding:20px;">是否确认解除该员工的隔离登记记录</p>
          </div>
        </el-col>
      </el-row>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="isolationDialog = false">取 消</el-button>
        <el-button type="primary" @click="quarantineRegisterEdit" v-show="isEdit">更新隔离登记</el-button>
        <el-button type="primary" @click="relieve" v-show="isRelieve">解除</el-button>
      </span>
    </el-dialog>

    <!-- 新增隔离登记 -->
  <el-dialog title="隔离登记" :visible.sync="quarantineRegisterAddDialog" width="650px" center top="3%" append-to-body>
      <v-quarantine-register-add v-if="quarantineRegisterAddDialog" @init="init" :id="id" :baseId="baseId"
                        @closeDialog="quarantineRegisterAddDialog= false"></v-quarantine-register-add>
    </el-dialog>
  </div>
</template>

<script>
import * as global from "../../config/mUtils";
import * as getData from "../../service/getData";
export default {
  data() {
    return {
      // orderComment: {},
      // orderDepartment: {},
      // lookBigImgDialog: false,
      // imgUrl: '',
      // odJson: []
      vrInfo: {
        baseName: "", //姓名
        // vrSex: 3,                            //1/男 2/女 3/未知
        baseCompanyName: "", //所在企业
        baseIdcrad: "", //身份证号码
        basePhone: "", //手机号码
        baseProvince: "", //户籍 省
        baseCity: "", //户籍 市
        baseDistrict: "", //户籍 区
        erLocation: "", //当前位置
        erReworkTime: "", //预计复工（返园）时间
        erHealth: 0, //是否有发热、乏力、干咳等症状1/正常  2/异常
        erHealthRemark: "",
        erContact: 0, //疫区接触史1/无  2/有
        erContactRemark: "", //疫区接触史描述
        erIsAirplane: 2, //涉及交通工具情况  是否坐飞机  1/是  2/否
        erIsBulletTrain: 2, //涉及交通工具情况  是否坐动车 1/是  2/否
        erIsBus: 2, //涉及交通工具情况  是否坐汽车  1/是 2/否
        erIsPrivateCar: 2, //私家车
        erFlightNumber: "",
        erTrainService: "",
        erBusNumber: "",
        // vrTrainRemark: '',                //行程描述
        erOtherRemark: "", //其他备注描述

        erCreateTime: "", //登记时间
        erHolidayProvince: "", //假期所在地区 省
        erHolidayCity: "", //假期所在地区 市
        erHolidayDistrict: "", //假期所在地区 区
        erHolidayAddress: "", //假期所在地居住地址
        erIsReturn: 0, //是否返回工作所在地 1/已返回 2/未返回
        erReturnTime: "", //返程时间
        erContactHistory: 1, //是否有新型冠状感染者接触史 1/无  2/有
        erContactHistoryRemark: "", //是否有新型冠状感染者接触史情况描述
        // erIsRework: 2,
        // erLeaveTime: "",
        erFamilyHealth: 2,
        erFamilyHealthRemark: "",
        erIsIsolation: 1,
        // erIsolationStartTime: new Date().format("yyyy-MM-dd"),
        // erIsolationEndTime: '',

        // healthCodeType:'',
        // healthCodeContent:'',
      },
      quarantineInfo:{
        quarantineWay:1,
        quarantineStartTime:"",
        quarantineDays:'',
        quarantinePerson:'',
        quarantineDescription:'',
        quarantineEndTime:'',
        quarantineAdminName:'',
        companyName:''

      },
      isolationDialog:false,
      quarantine:null,
      quarantineRegisterAddDialog:false,
      isEdit:false,
      isRelieve:false,
      healthCode:{
        healthCodeContent: '',
        width: 74,
        height: 74,
        type: '',
      },
      imgUrl:'',
    };
  },
  created() {},
  mounted() {    
    this.init();
  },
  props: ["id","baseId","activeId"],
  computed: {},
  methods: {
    timeFormat(time) {
      return global.toDateTime(time);
    },
    orginText(text) {
      switch (text) {
        case 1:
          return "微信提交";
        case 2:
          return "后台添加";
      }
    },
    close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    init() {
      getData.isIsolationRegister(this.baseId).then(res=>{
      if (res.data.code != 'success') {
            this.$message.error(res.data.message);
            return;
          }
      let data=res.data.data
      this.quarantine=data.quarantine
      if(this.quarantine!=null){
        
        this.getQuarantine(this.quarantine.quarantineId)
      }
      
    }).catch(_ => {
          console.log(_);
        });

      getData.vrDetail(this.id).then(res => {
        let data = res.data.data;
        this.vrInfo.baseName = data.epidemicRegister.baseName; //姓名
        //  this.vrInfo.vrSex=data.epidemicRegister.vrSex;                            //1/男 2/女 3/未知
        this.vrInfo.baseCompanyName = data.epidemicRegister.baseCompanyName; //所在企业
        this.vrInfo.baseIdcrad = data.epidemicRegister.baseIdcrad; //身份证号码
        this.vrInfo.basePhone = data.epidemicRegister.basePhone; //手机号码
        this.vrInfo.baseProvince = data.epidemicRegister.baseProvince; //户籍 省
        this.vrInfo.baseCity = data.epidemicRegister.baseCity; //户籍 市
        this.vrInfo.baseDistrict = data.epidemicRegister.baseDistrict; //户籍 区
        this.vrInfo.erLocation = data.epidemicRegister.erLocation; //当前位置
        this.vrInfo.erReworkTime = data.epidemicRegister.erReworkTime; //预计复工（返园）时间
        this.vrInfo.erHealth = data.epidemicRegister.erHealth; //身体状况1/正常  2/异常
        this.vrInfo.erHealthRemark = data.epidemicRegister.erHealthRemark;
        this.vrInfo.erContact = data.epidemicRegister.erContact; //疫区接触史1/无  2/有
        this.vrInfo.erContactRemark = data.epidemicRegister.erContactRemark; //疫区接触史描述
        this.vrInfo.erIsAirplane = data.epidemicRegister.erIsAirplane; //涉及交通工具情况  是否坐飞机  1/是  2/否
        this.vrInfo.erIsBulletTrain = data.epidemicRegister.erIsBulletTrain; //涉及交通工具情况  是否坐动车 1/是  2/否
        this.vrInfo.erIsBus = data.epidemicRegister.erIsBus; //涉及交通工具情况  是否坐汽车  1/是 2/否
        this.vrInfo.erIsPrivateCar = data.epidemicRegister.erIsPrivateCar;
        this.vrInfo.erFlightNumber = data.epidemicRegister.erFlightNumber;
        this.vrInfo.erTrainService = data.epidemicRegister.erTrainService;
        this.vrInfo.erBusNumber = data.epidemicRegister.erBusNumber;
        //  this.vrInfo.vrTrainRemark= data.epidemicRegister.vrTrainRemark;              //行程描述
        this.vrInfo.erOtherRemark = data.epidemicRegister.erOtherRemark; //其他备注描述
        this.vrInfo.erCreateTime = data.epidemicRegister.erCreateTime; 
        // this.vrInfo.erIsRework = data.epidemicRegister.erIsRework; 
        // this.vrInfo.erLeaveTime = data.epidemicRegister.erLeaveTime; 
        this.vrInfo.erFamilyHealth = data.epidemicRegister.erFamilyHealth; 
        this.vrInfo.erFamilyHealthRemark = data.epidemicRegister.erFamilyHealthRemark; 
        this.vrInfo.erIsIsolation = data.epidemicRegister.erIsIsolation; 
        // this.vrInfo.erIsolationStartTime = data.epidemicRegister.erIsolationStartTime; 
        this.vrInfo.erIsolationEndTime = data.epidemicRegister.erIsolationEndTime; 
        // this.vrInfo.erHaveReworkTime = data.epidemicRegister.erHaveReworkTime; 
        
        (this.vrInfo.erHolidayProvince =
          data.epidemicRegister.erHolidayProvince), //假期所在地区 省
          (this.vrInfo.erHolidayCity = data.epidemicRegister.erHolidayCity), //假期所在地区 市
          (this.vrInfo.erHolidayDistrict =
            data.epidemicRegister.erHolidayDistrict), //假期所在地区 区
          (this.vrInfo.erHolidayAddress =
            data.epidemicRegister.erHolidayAddress), //假期所在地居住地址
          (this.vrInfo.erIsReturn = data.epidemicRegister.erIsReturn), //是否返回工作所在地 1/已返回 2/未返回
          (this.vrInfo.erReturnTime = data.epidemicRegister.erReturnTime), //返程时间
          (this.vrInfo.erContactHistory =
            data.epidemicRegister.erContactHistory), //是否有新型冠状感染者接触史 1/无  2/有
          (this.vrInfo.erContactHistoryRemark =
            data.epidemicRegister.erContactHistoryRemark); //是否有新型冠状感染者接触史情况描述

            this.healthCode.healthCodeType=data.healthCode.healthCodeType;
            this.healthCode.healthCodeContent=data.healthCode.healthCodeContent;
            // this.getImage()
            this.imgUrl='company/viral/getImage?healthCodeContent='+this.healthCode.healthCodeContent+'&width=74'+'&height=74'+'&type='+this.healthCode.healthCodeType
          console.log(this.imgUrl,111)
      });
    },
    /* getImage(){
      getData.getImage(this.healthCode).then(res=>{
        console.log(res)
      }).catch(_=>{
        console.log(_)
      })
    }, */
    getQuarantine(id){
      getData.getQuarantine(id).then(res=>{
        let data=res.data.data.quarantine
        this.quarantineInfo.quarantineWay=data.quarantineWay
        this.quarantineInfo.quarantineStartTime=data.quarantineStartTime
        this.quarantineInfo.quarantineDays=data.quarantineDays
        this.quarantineInfo.quarantinePerson=data.quarantinePerson
        this.quarantineInfo.quarantineDescription=data.quarantineDescription
        this.quarantineInfo.quarantineEndTime=data.quarantineEndTime
        this.quarantineInfo.quarantineAdminName=data.quarantineAdminName
        this.quarantineInfo.companyName=data.companyName
      }).catch(_=>{
        console.log(_)
      })
    },
    quarantineRegisterEdit(){
      this.quarantineRegisterAddDialog=true;
      this.isolationDialog=false;
    },

    relieve(){
      this.isolationDialog=false;
      getData.deleteQuarantine(this.quarantine.quarantineId).then(res=>{
        console.log(res)
        if(res.data.code=='success'){
          this.$message.success("解除成功！");
          this.init()
        }else{
          this.$message.error("解除失败！");
        }
      }).catch(_=>{
        console.log(_)
      })
    },
    relieveTheIsolation(){
      this.isolationDialog=true;
      this.isRelieve=true
      this.isEdit=false
    },
    editTheIsolation(){
      this.isolationDialog=true;
      this.isEdit=true
      this.isRelieve=false
    },
    dowloadImg(){
      window.location.href='company/viral/getImage?healthCodeContent='+this.healthCode.healthCodeContent+'&width=200'+'&height=200'+'&type='+this.healthCode.healthCodeType+'&down=1'+'&name='+'健康码'
    }
  },
  components: {},
  watch: {}
};
</script>
<style scoped lang="scss">
@import "../../assets/css/mixin";
</style>
<style lang="scss">
.g-assign-item {
  .el-form-item__label {
    padding: 0;
  }
}
.title-label-right {
  float: right;
  color: #169bd5;
}
.g-basic-info {
  .info-item {
    border: 1px dashed #eee;
    padding: 10px;
    padding-bottom: 0;
    margin-bottom: 10px;
  }
  p {
    span {
      color: #666;
      &.red {
        color: #ff0000;
      }
      &.green {
        color: #00ae0d;
      }
    }
  }
}
.font-blod {
  font-weight: 700;
}
.quarantine-condition {
  font-size: 14px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/防疫/prevent-plague-details.vue